import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: []
})
export class PageComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/page/page.component.ts